import 'clamp';

export default ['$timeout', function ($timeout) {
    return {
        'restrict': 'A',
        'scope': {
            'clampLines': '@',
            'clampValue': '@'
        },
        'link': function link(scope, elt) {
            function update() {
                $timeout(function () {
                    var jqElement = angular.element(elt[0]).empty();
                    jqElement.append(document.createTextNode(scope.clampValue));
                    window.$clamp(elt[0], {
                        clamp: scope.clampLines
                    });
                });
            }

            update();
            scope.$watch('clampValue', update);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/ClampTextDirective.js
// module id = 774
// module chunks = 0